import {Button, HStack, Image, Input, StackProps, Text, VStack} from "@chakra-ui/react";
import {OneElementSelector, OneElementSelectorProps} from "../OneElementSelector/OneElementSelector";
import * as React from "react";
import enotecaLogo from "../../../assets/images/enoteca_regionale_logo.png";
import poweredSmartVenues from "../../../assets/images/powered_smart_venues.png";
import {IS_SMARTVENUES} from "../../../utils/Utils";
import {SmartVenuesLogo} from "../../atoms/SvgImage";
import {ColorsClass} from "../../../theme/colors";

export interface FilterSidebarProps {
    stackProps?: StackProps;
    searchProps?: {
        searchInput?: string;
        onChangeText?: (text: string) => void;
        placeholder?: string;
    };
    selectors?: OneElementSelectorProps[];
    buttons?: {
        cancel?: {
            text: string;
            onClick: () => void;
        };
        filter?: {
            text: string;
            onClick: () => void;
        };
    };
}

export const FilterSidebar = ({searchProps, selectors, buttons, stackProps}: FilterSidebarProps) => {
    const {searchInput, placeholder, onChangeText} = searchProps || {};

    const {cancel, filter} = buttons || {};
    const {text: cancelText, onClick: cancelOnClick} = cancel || {};
    const {text: filterText, onClick: filterOnClick} = filter || {};

    return <VStack w={'100%'} flex={1} p={"24px"} gap={"24px"} {...stackProps}>
        <HStack w={'80%'} gap={"16px"}>
            {IS_SMARTVENUES ? <>
                <SmartVenuesLogo w={"80%"} strokeColor={"#006c4b"}/>
            </> : <>
                <Image src={enotecaLogo} width={"60%"}/>
                <Image src={poweredSmartVenues} width={"30%"}/>
            </>}
        </HStack>

        {searchProps && <VStack w={'100%'} alignItems={'stretch'} mt={'24px'}>
            <Text alignSelf={'flex-start'} color={'primary.400'} fontWeight={'bold'}>Cerca</Text>

            <Input
                variant='filled'
                colorScheme={"primary"}
                type={'text'}
                value={searchInput}
                onChange={event => onChangeText?.(event.target.value)}
                placeholder={placeholder}
                _placeholder={{fontSize: 14}}
                style={{
                    height: 40,
                    minHeight: 40,
                    borderRadius: 4,
                    backgroundColor: "#EDF2F7",
                    paddingLeft: 8,
                    paddingRight: 8,
                }}
            />
        </VStack>}

        {selectors && selectors.map((value, index) => {
            return <OneElementSelector key={`selector_key_${index}`} {...value}/>
        })}

        <Button mt={'48px'} variant={'outline'} style={{
            border: "1px solid black", borderRadius: 4, height: 40, fontWeight: "bold"
        }} alignSelf={'stretch'} colorScheme={'chatbotBlue'}
                onClick={cancelOnClick}>{cancelText}</Button>

        <Button alignSelf={'stretch'} variant={'outline'} colorScheme={'primary'} onClick={filterOnClick}>
            {filterText}
        </Button>
    </VStack>
}
